import { create as s } from "zustand";
import { devtools as n, subscribeWithSelector as l } from "zustand/middleware";
import { produce as i } from "immer";
import "react/jsx-runtime";
import "react";
import "@placer-ui/components";
import "./index.es4.js";
import "./index.es20.js";
import "./index.es12.js";
import "@tanstack/react-query";
import "qs";
import "@turf/turf";
import "./index.es175.js";
import "./index.es176.js";
import "./index.es46.js";
import "./index.es99.js";
import "./index.es203.js";
import "./index.es204.js";
import "./index.es205.js";
import "./index.es206.js";
import "use-debounce";
import "@deck.gl/geo-layers/typed";
import "@deck.gl/core/typed";
import "@deck.gl/layers/typed";
import "react-map-gl";
import "mapbox-gl";
import "fabric";
import "./index.es170.js";
import "lodash/fp";
import "lodash/throttle";
import "lodash/debounce";
import "queue";
import "geobuckets";
import "./index.es207.js";
import "./index.es59.js";
import "./index.es74.js";
import "./index.es82.js";
import "./index.es113.js";
import "@deck.gl/extensions/typed";
import "kdbush";
import "./index.es208.js";
import "./index.es84.js";
import "./index.es78.js";
import "./index.es80.js";
import "@deck.gl/aggregation-layers/typed";
import "./index.es86.js";
import "lodash";
import "./index.es23.js";
import "./index.es18.js";
import "./index.es72.js";
import "./index.es209.js";
import "./index.es103.js";
import "@sentry/react";
import "./index.es43.js";
import "@loaders.gl/core";
import "@loaders.gl/mvt";
import "./index.es90.js";
import "./index.es91.js";
import "./index.es92.js";
import "react-dom";
import "classnames";
import "./index.es210.js";
import "@deck.gl/mapbox/typed";
import "./index.es211.js";
import "./index.es212.js";
import "./index.es213.js";
import "./index.es214.js";
import "./index.es215.js";
import "./index.es216.js";
import "./index.es217.js";
import "./index.es179.js";
import "./index.es218.js";
import "./index.es219.js";
import "./index.es158.js";
import "./index.es220.js";
import "./index.es221.js";
import "./index.es222.js";
import "./index.es223.js";
import "./index.es224.js";
import "@placer-ui/hooks";
import "./index.es225.js";
import "./index.es226.js";
import "./index.es166.js";
import "./index.es227.js";
import "./index.es228.js";
import "./index.es229.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es45.js";
import "./index.es39.js";
import "./index.es40.js";
import "zustand/react/shallow";
import "./index.es230.js";
import { MB_BASEMAP_MAPPING as d } from "./index.es117.js";
import "./index.es231.js";
import "./index.es232.js";
import "./index.es233.js";
import "./index.es234.js";
import "./index.es131.js";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "./index.es235.js";
import "./index.es236.js";
import "./index.es137.js";
import "./index.es138.js";
import "./index.es237.js";
import "./index.es238.js";
import "./index.es143.js";
import "./index.es239.js";
import f from "./index.es240.js";
var g = /* @__PURE__ */ ((r) => (r.POI = "poi", r.PL = "pl", r.PIN_DISPLAY = "pinDisplay", r))(g || {});
const Me = s()(
  n(
    l((r, a) => ({
      maps: {},
      actions: {
        initMapStore: ({ mapId: o, mapRef: e, printMode: t = !1 }) => {
          const p = a().maps;
          if (p && p[o]) {
            console.warn(`Map ID: ${o} already exists within the PLMapboxStoreV2`), r(
              i((m) => {
                m.maps[o] = {
                  ...m.maps[o],
                  mapRef: e
                };
              }),
              !1,
              `initMapStore updateMapRef - ${o}`
            );
            return;
          }
          r(
            i((m) => {
              m.maps[o] = {
                mapRef: e,
                isMapboxLoaded: !1,
                isInitialLayerConfigLoaded: !1,
                isInitiallyLoaded: !1,
                activeMapLoadingBar: !1,
                activeSearchLoadingBar: !1,
                externalLoadingStatus: !1,
                printMode: t,
                toolMode: "select",
                cursor: "grab",
                mapLegend: {
                  legendItems: {}
                },
                popups: {}
              };
            }),
            !1,
            `initMapStore - ${o}`
          );
        },
        deleteMapRef: (o) => {
          r(
            i((e) => {
              e.maps[o] = {
                ...e.maps[o],
                mapRef: void 0,
                isMapboxLoaded: !1
              };
            }),
            !1,
            `deleteMapRef - ${o}`
          );
        },
        deleteMapStore: (o) => {
          r(
            i((e) => {
              delete e.maps[o];
            }),
            !1,
            `deleteMapStore - ${o}`
          );
        },
        isMapStoreLoaded: (o) => {
          var t;
          return !!((t = a().maps) == null ? void 0 : t[o]);
        },
        setState: ({ mapId: o, ...e }) => {
          r(
            i((t) => {
              Object.entries(e).forEach(([p, m]) => {
                t.maps[o][p] = m;
              });
            }),
            !1,
            `setState - ${o}`
          );
        },
        setBasemap: ({ mapId: o, basemapKey: e }) => {
          r(
            i((t) => {
              t.maps[o].basemap = d[e];
            }),
            !1,
            `setBasemap - ${o}`
          );
        },
        setCursor: ({ mapId: o, cursor: e }) => {
          r(
            i((t) => {
              t.maps[o].cursor = e;
            }),
            !1,
            `setCurosr - ${o}`
          );
        },
        setExternalLoadingStatus: ({ mapId: o, isLoading: e }) => {
          r(
            i((t) => {
              t.maps[o] && (t.maps[o].externalLoadingStatus = e);
            }),
            !1,
            `setExternalLoadingStatus - ${o}`
          );
        },
        setActiveMapLoadingBar: ({ mapId: o, isActive: e }) => {
          r(
            i((t) => {
              t.maps[o].activeMapLoadingBar = e;
            }),
            !1,
            `setActiveMapLoadingBar-${e}`
          );
        },
        setLegendItems: ({ mapId: o, items: e }) => {
          r(
            i((t) => {
              if (!t.maps[o]) {
                console.warn(`Cannot set legend items: 
                                    Map store for mapId "${o}" is not loaded yet.`);
                return;
              }
              t.maps[o].mapLegend.legendItems = e;
            }),
            !1,
            `setLegendItems - ${o}`
          );
        },
        addLegendItem: ({ mapId: o, item: e }) => {
          const t = e.id || f();
          return e.id = t, r(
            i((p) => {
              if (!p.maps[o]) {
                console.warn(`Cannot add legend item: 
                                    Map store for mapId "${o}" is not loaded yet.`);
                return;
              }
              p.maps[o].mapLegend.legendItems[t] = e;
            }),
            !1,
            `addLegendItem - ${o}`
          ), t;
        },
        removeLegendItem: ({ mapId: o, itemId: e }) => {
          r(
            i((t) => {
              if (!t.maps[o]) {
                console.warn(`Cannot remove legend item: 
                                    Map store for mapId "${o}" is not loaded yet.`);
                return;
              }
              delete t.maps[o].mapLegend.legendItems[e];
            }),
            !1,
            `removeLegendItem - ${o}`
          );
        },
        updateLegendItem: ({ mapId: o, itemId: e, updatedItemData: t }) => {
          r(
            i((p) => {
              if (!p.maps[o].mapLegend.legendItems[e]) {
                console.warn(
                  `Legend item with id ${e} not found. Cannot update.`
                );
                return;
              }
              p.maps[o].mapLegend.legendItems[e] = t;
            }),
            !1,
            `updateLegendItem - ${o}`
          );
        },
        setMapPopups: (o) => {
          r(
            i((e) => {
              e.maps[o.mapId].popups = o.popups;
            }),
            !1,
            `setMapPopups - ${o.mapId}`
          );
        },
        setHoverComponent: ({ mapId: o, componentType: e, componentProps: t }) => {
          r(
            i((p) => {
              (!p.maps[o].hover || typeof p.maps[o].hover != "object") && (p.maps[o].hover = {}), p.maps[o].hover.componentType = e, p.maps[o].hover.componentProps = t;
            }),
            !1,
            `setHoverComponent - ${o}`
          );
        },
        clearHoverComponent: ({ mapId: o }) => {
          r(
            i((e) => {
              e.maps[o] && (e.maps[o].hover = void 0);
            }),
            !1,
            `clearHoverComponent - ${o}`
          );
        }
      }
    })),
    {
      name: "PLMapboxStoreV2",
      enabled: !!(window && window.__REDUX_DEVTOOLS_EXTENSION__)
    }
  )
);
export {
  g as PLPopupTypes,
  Me as usePLMapboxStoreV2
};
//# sourceMappingURL=index.es6.js.map
